import React from 'react';
import TierBadge from '@components/common/TierBadge';
import { ScheduleItem, ScheduleItemContract } from '@app-types';
import { tierToVariant } from '@utils/badgeMappers';
import GroupTierBadges from './GroupTierBadges';
import styles from './SchedulerTableCells.module.css';

// Get open conflicts for a contract
const getOpenConflicts = (contract: ScheduleItemContract) => {
  return (contract.conflicts || []).filter((c) => c.status !== 'resolved');
};

// Helper: Check if schedule item has tier conflicts
const hasTierConflict = (scheduleItem: ScheduleItem): boolean => {
  const allConflicts = scheduleItem.contracts.flatMap((c) => getOpenConflicts(c));
  return allConflicts.some((c) => c.conflict_type_code === 'TIER_MISMATCH');
};

const TierCell: React.FC<{
  tier: string;
  scheduleItem?: ScheduleItem;
  isGroupRow?: boolean;
  isChildRow?: boolean;
}> = ({ tier, scheduleItem, isGroupRow, isChildRow }) => {
  const hasBundleTierConflict = scheduleItem ? hasTierConflict(scheduleItem) : false;

  // Parent row in bundle - show tier(s)
  if (isGroupRow && !isChildRow && scheduleItem) {
    return <GroupTierBadges scheduleItem={scheduleItem} tier={tier} hasBundleTierConflict={hasBundleTierConflict} />;
  }

  // Child rows in bundle WITH conflict - show their actual tier
  if (isChildRow && hasBundleTierConflict) {
    return <TierBadge variant={tierToVariant(tier)}>{tier}</TierBadge>;
  }

  // Child rows in bundle WITHOUT conflict - show dash
  if (isChildRow) {
    return <span className={styles.emptyCell}>—</span>;
  }

  // Single contract (not in bundle) - show tier badge
  return <TierBadge variant={tierToVariant(tier)}>{tier}</TierBadge>;
};

export default TierCell;
